import { AppGlobalState } from 'modules/types'
import { createBasicSelectors } from 'modules/utils/helpers/createBasicSelectors'

export default {
  ...createBasicSelectors('comments'),
  syncProgress: (state: AppGlobalState) => state.comments.syncProgress,
}
